import { createFileRoute } from "@tanstack/react-router";

import FinalizePlaidPaymentMethod from "@/shared/components/payment-methods/FinalizePlaidPaymentMethod";

export const Route = createFileRoute("/_authenticated/settings/payment-methods/new/final-steps")({
  component: FinalizePlaidPaymentMethod,
  context: () => ({ permissions: "settings.payment-methods" }),
});
